import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";
import { useGetUserAcademicPeriod } from "./useGetUserAcademicPeriod";

export interface IHallTicket {
  slcm_hallticketid: string;
  slcm_examname: string;
  slcm_academicperiod: string;
  slcm_hallticket: string;
}

export const useGetHallTicketDetails = () => {
  const { user, siteId } = useAuth();
  const [getHallTickets, { isLoading }] = useLazyReadMultipleQuery();
  const [hallTickets, setHallTickets] = useState<IHallTicket[]>([]);
  const { academicPeriodId, isLoading: isUserAcademicLoading } = useGetUserAcademicPeriod();

  useEffect(() => {
    const fetchHallTickets = async () => {
      if (!user?.contactId || !siteId || !academicPeriodId) return;

      try {
        const data = await getHallTickets({
          userId: user?.contactId || user?.entityId,
          portalId: siteId || "",
          tableId: "slcm_hallticket",
          fieldList: [
            "slcm_hallticket",
            "slcm_hallticketid",
            "slcm_examname",
            "slcm_academicperiod",
            "slcm_student"
          ],
          filters: [
            {
              group: 0,
              filters: [
                {
                  field: "slcm_academicperiod", type: FieldFilterType.Const, value: academicPeriodId,
                },
                {
                  field: "slcm_student", type: FieldFilterType.Const, value: user.contactId,
                },
              ],
            },
          ],

        }).unwrap();

        if (data?.records?.length) {
          setHallTickets(data.records as IHallTicket[]);
        } else {
          setHallTickets([]);
          console.warn("No hall ticket found for the current academic period.");
        }
      } catch (error) {
        console.error("Error fetching hall tickets:", error);
      }
    };

    fetchHallTickets();
  }, [user?.contactId, siteId, academicPeriodId, getHallTickets]);

  return { hallTickets, isLoading: isLoading || isUserAcademicLoading };
};
